export const useScrolltriggerContainer = () => {
  function getScrolltriggerContainer(content, containerClassName) {
    let scrollContainer;
    for (let element = content.parentElement; element !== document.body; element = element.parentElement) {
      if (element.classList.contains(containerClassName)) {
        scrollContainer = element;
        break;
      }
    }
    
    return scrollContainer;
  }
  
  return {
    getScrolltriggerContainer
  };
};
